class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.drivertrigger?.exists) {
      this.handleDriverTrigger = this.handleDriverTrigger.bind(this)

      this.els.drivertrigger.elements.forEach(driverTriggerEl => {
        this.listeners.add(driverTriggerEl, `click`, this.handleDriverTrigger)
      })
    }

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.panel !== triggerEl.dataset.panel,
      )
    })
  }

  handleDriverTrigger (event) {
    const driverTriggerEl = event.target.closest(
      this.els?.drivertrigger?.selector,
    )

    this.els.driverimage.elements.forEach(driverimageEl => {
      driverimageEl.setAttribute(
        'aria-hidden',
        driverimageEl.dataset.driver !== driverTriggerEl.dataset.driver,
      )
    })
    this.els.drivertrigger.elements.forEach(drivertrigger => {
      if (drivertrigger.dataset.mainTrigger === 'true') {
        drivertrigger.setAttribute(
          'aria-pressed',
          drivertrigger.dataset.driver === driverTriggerEl.dataset.driver,
        )
      }
    })
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}

class SizeGuideTableSelector extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.sizeTables = this.querySelectorAll('.pg-SizeGuide_Tables')
    this.genderSelector = this.querySelector('#pg-SizeGuide_Genders')
    this.categorySelectors = this.querySelectorAll('input[name="category"]')

    this.genderSelector.addEventListener(
      'change',
      this.selectionChanged.bind(this),
    )

    this.categorySelectors.forEach(trigger =>
      trigger.addEventListener('change', this.selectionChanged.bind(this)),
    )

    this.handleParams()
    this.showActiveTables()
  }

  selectionChanged () {
    this.activeGender = this.genderSelector.value
    this.activeCategory = this.querySelector(
      'input[name="category"]:checked',
    ).value

    this.showActiveTables()
  }

  handleParams () {
    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.has('size-guide-gender')) {
      this.activeGender = urlParams.get('size-guide-gender')
      this.genderSelector.value = this.activeGender
    }

    if (urlParams.has('size-guide-category')) {
      const categoryValue = urlParams.get('size-guide-category')
      const categoryInput = this.querySelector(
        `input[name="category"][value="${categoryValue}"]`,
      )

      if (!categoryInput) return

      this.querySelectorAll('input[name="category"]').forEach(input => {
        input.checked = false
      })

      categoryInput.checked = true
      this.activeCategory = categoryInput.value
    }
  }

  showActiveTables () {
    const activeGender = this.genderSelector.value
    const activeCategory = this.querySelector('input[name="category"]:checked')
      .value

    const url = new URL(window.location)
    url.searchParams.set('size-guide-gender', activeGender)
    url.searchParams.set('size-guide-category', activeCategory)
    window.history.replaceState({}, '', url)

    this.sizeTables.forEach(table => {
      if (
        table.getAttribute('data-gender') === activeGender &&
        table.getAttribute('data-category') === activeCategory
      ) {
        table.classList.add('pg-SizeGuide_TablesActive')
      } else {
        table.classList.remove('pg-SizeGuide_TablesActive')
      }
    })
  }
}

if (!customElements.get('size-guide-table-selector')) {
  customElements.define('size-guide-table-selector', SizeGuideTableSelector)
}

class SizeGuideMetrics extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.table = this.querySelector('[data-sizeguide-metric-toggle-el="table"]')
    this.metricTriggers = this.querySelectorAll(
      '[data-sizeguide-metric-toggle-el="trigger"]',
    )

    this.metricTriggers.forEach(trigger =>
      trigger.addEventListener('change', this.metricTriggered.bind(this)),
    )
  }

  metricTriggered (e) {
    const activeTriggerValue = this.querySelector(
      '[data-sizeguide-metric-toggle-el="trigger"]:checked',
    ).value

    if (this.table && activeTriggerValue) {
      this.table.setAttribute('data-table-metric', activeTriggerValue)
    }
  }
}

if (!customElements.get('size-guide-metrics')) {
  customElements.define('size-guide-metrics', SizeGuideMetrics)
}
